document.addEventListener('DOMContentLoaded', function() {

  // Show spinner on ajax:beforeSend and hide it on ajax:complete
  document.querySelectorAll('.show-spinner').forEach(function(elem) {
    elem.addEventListener('ajax:beforeSend', function() {
      document.querySelector('.spinner').classList.toggle('hide');
    });

    elem.addEventListener('ajax:complete', function() {
      document.querySelector('.spinner').classList.toggle('hide');
    });
  });

  // Handle click event for buttons with class 'click-btn'
  document.addEventListener('click', function(e) {
    const target = e.target;
    if (target.matches('a.click-btn')) {
      e.preventDefault();
      const updateUrl = target.dataset.updateUrl;
      const updateMethod = target.dataset.updateMethod || 'post';

      $.ajax({
        url: updateUrl,
        method: updateMethod,
        dataType: 'json',
        success: function(response) {
          if (target.classList.contains('feature')) {
            target.classList.toggle('btn-warning');
            target.classList.toggle('btn-success');
          } else {
            target.classList.toggle('btn-primary');
            target.classList.toggle('btn-success');
          }

          const newMethod = updateMethod === 'post' ? 'delete' : 'post';
          target.dataset.updateMethod = newMethod;
          target.dataset.updateUrl = response.url;
          target.setAttribute('data-update-url', response.url);
        },
        error: function(xhr) {
          const response = JSON.parse(xhr.responseText);
          alert(response.errors[0] || 'Request failed');
        }
      });
    }
  });

  // Filter elements based on the input in #filter
  const filterInput = document.querySelector('#filter');
  if (filterInput) {
    filterInput.addEventListener('keyup', function() {
      const filterValue = this.value.toLowerCase();
      const regex = new RegExp(filterValue, 'i');

      // Filter .search-btn buttons
      document.querySelectorAll('.search-btn').forEach(function(btn) {
        if (btn.textContent.search(regex) < 0) {
          btn.closest('div').style.display = 'none';
        } else {
          btn.closest('div').style.display = '';
        }
      });

      // Filter .app-button links (for Assigned Applications on user profile)
      document.querySelectorAll('.searchable .app-button').forEach(function(link) {
        if (link.textContent.search(regex) < 0) {
          link.style.display = 'none';
        } else {
          link.style.display = '';
        }
      });

      if (!filterValue) {
        document.querySelectorAll('.searchable button').forEach(function(btn) {
          btn.closest('div').style.display = '';
          btn.style.display = '';
        });
        document.querySelectorAll('.searchable .app-button').forEach(function(link) {
          link.style.display = '';
        });
      }
    });
  }

  // Filter links based on the input in #filter
  if (filterInput) {
    filterInput.addEventListener('keyup', function() {
      const filterValue = this.value.toLowerCase();
      const regex = new RegExp(filterValue, 'i');

      document.querySelectorAll('a.link').forEach(function(link) {
        if (link.textContent.search(regex) < 0) {
          link.closest('div').style.display = 'none';
        } else {
          link.closest('div').style.display = '';
        }
      });

      if (!filterValue) {
        document.querySelectorAll('a.link').forEach(function(link) {
          link.closest('div').style.display = '';
        });
      }
    });
  }

  // Filter names based on the input in #filter
  if (filterInput) {
    filterInput.addEventListener('keyup', function() {
      const filterValue = this.value.toLowerCase();
      const regex = new RegExp(filterValue, 'i');

      document.querySelectorAll('td.name').forEach(function(td) {
        if (td.textContent.search(regex) < 0) {
          td.closest('tr').style.display = 'none';
        } else {
          td.closest('tr').style.display = '';
        }
      });

      if (!filterValue) {
        document.querySelectorAll('td.name').forEach(function(td) {
          td.closest('tr').style.display = '';
        });
      }
    });
  }

  // Handle keyup events for dynamic attributes
  const atrCont = document.querySelectorAll('.attributeContainer');
  if (atrCont) {
    atrCont.forEach(function(container) {
      container.addEventListener('keyup', function(e) {
        if (e.target.matches('.dynamicAttributeName')) {
          const nameElem = e.target;
          const valueElem = nameElem.closest('.rm').querySelector('.attribute-value');
          if (!valueElem) return;
          
          const newKey = nameElem.value.toLowerCase().trim();
          
          if (newKey) {
            // Update the value field's name attribute to match the new key
            // Rails hstore will replace entire hash, so old key will be automatically removed
            valueElem.setAttribute('id', 'user_settings_' + newKey);
            valueElem.setAttribute('name', 'user[settings][' + newKey + ']');
            valueElem.setAttribute('placeholder', 'value for ' + newKey);
          }
        }
      });

      container.addEventListener('click', function(e) {
        if (e.target.matches('.remove')) {
          e.preventDefault();
          e.stopPropagation();
          
          const attributeRow = e.target.closest('.rm');
          if (!attributeRow) return;
          
          // Get the key name before removing
          const valueInput = attributeRow.querySelector('.attribute-value');
          let keyToRemove = null;
          
          if (valueInput && valueInput.getAttribute('name')) {
            // Extract key from name attribute (e.g., "user[settings][my_key]" -> "my_key")
            const match = valueInput.getAttribute('name').match(/\[([^\]]+)\]$/);
            keyToRemove = match ? match[1] : null;
          } else {
            // Fallback: try to get from the name input
            const nameInput = attributeRow.querySelector('.dynamicAttributeName');
            keyToRemove = nameInput ? nameInput.value.trim() : null;
          }
          
          // Remove the DOM element
          attributeRow.remove();
          
          // Add a hidden input with empty value to explicitly mark this key for removal
          // Rails hstore needs explicit empty values to remove keys
          if (keyToRemove) {
            const form = container.closest('form');
            if (form) {
              // Check if a removal marker already exists
              const existingMarker = form.querySelector('input[name="user[settings][' + keyToRemove + ']"][data-remove-marker]');
              if (!existingMarker) {
                const hiddenInput = document.createElement('input');
                hiddenInput.type = 'hidden';
                hiddenInput.name = 'user[settings][' + keyToRemove + ']';
                hiddenInput.value = '';
                hiddenInput.setAttribute('data-remove-marker', 'true');
                hiddenInput.className = 'remove-attribute-marker';
                form.appendChild(hiddenInput);
              }
            }
          }
          
          // Don't auto-submit - let user click Update button manually
          // This prevents unwanted redirects and gives user control
        }
      });
    });
  }

  // Handle adding dynamic attributes
  const addAttr = document.querySelector('.addAttribute');
  if (addAttr) {
    addAttr.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const template = document.querySelector('.attributeTemplate');
      if (!template) return;
      
      const newAttribute = document.createElement('div');
      newAttribute.classList.add('rm', 'form-group');
      newAttribute.setAttribute('style', 'margin-bottom: 15px;');
      newAttribute.innerHTML = template.innerHTML;
      
      // Insert before the "Add New Attribute" button's parent row
      const buttonRow = this.closest('.row');
      if (buttonRow) {
        buttonRow.insertAdjacentElement('beforebegin', newAttribute);
      } else {
        // Fallback: insert before the button itself
        this.insertAdjacentElement('beforebegin', newAttribute);
      }
      
      // Focus on the name input for better UX
      const nameInput = newAttribute.querySelector('.dynamicAttributeName');
      if (nameInput) {
        nameInput.focus();
      }
    });
  }

  // Show/Hide QR code
  const showQr = document.querySelector('.showQr')
  if (showQr) {
    document.querySelector('.showQr').addEventListener('click', function() {
      document.querySelector('.qr').classList.toggle('hide');
    });
  }

  // Submit form on adding attribute
  if (atrCont) {
    atrCont.forEach(function(container) {
      container.addEventListener('click', function(e) {
        if (e.target.matches('.adder')) {
          const form = e.target.closest('form');
          e.target.remove();
          form.submit();
        }
      });
    });
  }

  // Handle pagination links (only for AJAX-enabled pages like users/index)
  // Use a single event listener with a flag to prevent multiple attachments
  if (!window.paginationHandlerAttached) {
    window.paginationHandlerAttached = true;
    
    // Use event delegation to handle clicks on pagination links
    document.addEventListener('click', function(e) {
      // Only handle clicks on users page, not dashboard pages
      if (window.location.pathname.includes('/dashboard/')) {
        return;
      }
      
      // Check if the click is on a pagination link within .paginate_links
      let paginationLink = e.target;
      if (paginationLink.tagName !== 'A') {
        paginationLink = e.target.closest('a');
      }
      
      if (paginationLink && paginationLink.closest('.paginate_links')) {
        // Make sure it's not a disabled link and has a valid href
        var linkHref = paginationLink.href;
        if (!linkHref) return;
        
        // Parse the link URL to get pathname (compatible with older browsers)
        var linkPath = linkHref.split('?')[0].split('#')[0];
        var currentPath = window.location.pathname;
        
        // Only intercept if it's a users page pagination link
        if (linkPath === currentPath &&
            !paginationLink.classList.contains('disabled') && 
            !paginationLink.closest('.disabled')) {
          e.preventDefault();
          e.stopPropagation();
          
          // Make AJAX request with script dataType to execute the response
          $.ajax({
            url: linkHref,
            type: 'GET',
            dataType: 'script',
            success: function(data, textStatus, jqXHR) {
              // Success - the index.js.erb will handle updating the DOM
            },
            error: function(jqXHR, textStatus, errorThrown) {
              console.error('Pagination AJAX error:', textStatus, errorThrown);
              // Fallback to regular page navigation if AJAX fails
              window.location.href = linkHref;
            }
          });
          return false;
        }
      }
    });
  }

  // Bulk remove users from app
  const selectAll = document.querySelector('#select-all');
  const removeBtn = document.querySelector('#remove-selected-btn');

  if (selectAll && removeBtn) {
    selectAll.addEventListener('change', function() {
      const checkboxes = document.querySelectorAll('.user-checkbox');
      checkboxes.forEach(function(cb) {
        const row = cb.closest('tr');
        if (row && row.style.display !== 'none') {
          cb.checked = selectAll.checked;
        }
      });
      updateRemoveButton();
    });

    document.addEventListener('change', function(e) {
      if (e.target.matches('.user-checkbox')) {
        updateRemoveButton();
        const allVisible = document.querySelectorAll('.user-checkbox');
        const allChecked = Array.from(allVisible).every(function(cb) { return cb.checked; });
        selectAll.checked = allChecked;
      }
    });

    removeBtn.addEventListener('click', function() {
      const checked = document.querySelectorAll('.user-checkbox:checked');
      if (checked.length === 0) return;

      const count = checked.length;
      const msg = 'Are you sure you want to remove ' + count + ' user' + (count > 1 ? 's' : '') + ' from this application?\n\nThis will revoke their CAS access to this EMR instance.';
      if (!confirm(msg)) return;

      const userIds = Array.from(checked).map(function(cb) { return parseInt(cb.value); });
      const url = removeBtn.dataset.url;

      var csrfToken = document.querySelector('meta[name="csrf-token"]');
      $.ajax({
        url: url,
        method: 'DELETE',
        contentType: 'application/json',
        data: JSON.stringify({ user_ids: userIds }),
        dataType: 'json',
        headers: csrfToken ? { 'X-CSRF-Token': csrfToken.content } : {},
        success: function(response) {
          response.removed_user_ids.forEach(function(uid) {
            const row = document.querySelector('tr[data-user-id="' + uid + '"]');
            if (row) row.remove();
          });

          selectAll.checked = false;
          updateRemoveButton();

          var countSpan = document.querySelector('.user-count');
          if (countSpan) {
            var remaining = document.querySelectorAll('#users-tbody tr').length;
            countSpan.textContent = '(' + remaining + ')';
          }

          var tbody = document.querySelector('#users-tbody');
          if (tbody && tbody.children.length === 0) {
            var section = document.querySelector('.users-section');
            if (section) {
              section.innerHTML = '<div class="section-header"><h2 class="section-title">Assigned Users</h2></div>' +
                '<div class="empty-state"><p>No users are directly assigned to this application.</p></div>';
            }
          }
        },
        error: function(xhr) {
          var msg = 'Failed to remove users.';
          try { msg = JSON.parse(xhr.responseText).error || msg; } catch(e) {}
          alert(msg);
        }
      });
    });
  }

  function updateRemoveButton() {
    var btn = document.querySelector('#remove-selected-btn');
    if (!btn) return;
    var count = document.querySelectorAll('.user-checkbox:checked').length;
    btn.disabled = count === 0;
    var label = count > 0 ? 'Remove Selected (' + count + ')' : 'Remove Selected';
    btn.innerHTML = '<i class="fa fa-trash"></i> ' + label;
  }

  // User search on app show page
  var userSearch = document.querySelector('#user-search');
  if (userSearch) {
    userSearch.addEventListener('keyup', function() {
      var val = this.value.toLowerCase();
      document.querySelectorAll('#users-tbody tr').forEach(function(row) {
        var text = row.textContent.toLowerCase();
        row.style.display = text.indexOf(val) >= 0 ? '' : 'none';
      });
    });
  }

  // AJAX CAS logout
  const ajaxLogout = document.querySelector('a#ajax_cas_logout')
  if (ajaxLogout) {
    ajaxLogout.addEventListener('ajax:success', function(evt, data) {
      if (data.logout) {
        alert('User Was Logged-out from all Instances');
      } else {
        alert('User Was NOT Logged-out from all Instances');
      }
    });
    ajaxLogout.addEventListener('ajax:error', function() {
      console.log('Cannot log-out User');
    });
  }


  // Submit form on organization search change
  const userOrgSearch = document.querySelector('#users_org_search')
  if (userOrgSearch) {
    userOrgSearch.addEventListener('change', function() {
      this.closest('form').submit();
    });
  }

  // Update URL when filters form is submitted via AJAX to preserve filters on refresh
  // Handle both Rails UJS events and direct form submissions
  $(document).on('ajax:before submit', 'form.form-horizontal[method="get"]', function(e) {
    var form = $(this);
    var actionUrl = form.attr('action');
    
    // Only process if this is the users filter form
    if (actionUrl && (actionUrl.includes('/users') || actionUrl === '/users')) {
      // Build query string from form data
      var formData = form.serialize();
      
      // Remove any existing query string from action
      actionUrl = actionUrl.split('?')[0];
      
      // Build new URL with query parameters
      var newUrl = actionUrl + (formData ? '?' + formData : '');
      
      // Update URL without reloading the page
      window.history.pushState({path: newUrl}, '', newUrl);
      
      // Log for debugging
      console.log('Updated URL to:', newUrl);
    }
  });


});

// Re-run ready function when Turbo Drive replaces the page
document.addEventListener('turbo:load', function() {
  ready();
});
